export default __webpack_public_path__ + "static/media/historic_openapi.8e1f6005.yaml";